// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconInputSearch = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.4930394,12.1410984 C21.9545068,12.1410984 24.7705033,14.8624344 24.7705033,18.2075438 C24.7705033,21.5526532 21.9545068,24.2739892 18.4930394,24.2739892 C15.031572,24.2739892 12.2155755,21.5526532 12.2155755,18.2075438 C12.2155755,14.8624344 15.031572,12.1410984 18.4930394,12.1410984 M24.9935379,23.4839239 C26.2807873,22.0051386 26.9860788,20.1445241 26.9860788,18.2075438 C26.9860788,13.6819755 23.1760275,10 18.4930394,10 C13.8100513,10 10,13.6819755 10,18.2075438 C10,22.7331121 13.8100513,26.4150876 18.4930394,26.4150876 C20.2510986,26.4150876 21.9264429,25.9026514 23.3588125,24.929879 L28.4033086,30 L30,28.515862 L24.9935379,23.4839239 Z"
                transform="translate(-10 -10)"
            />
        </svg>
    );
};

export default React.memo(IconInputSearch);
